__turbopack_context__.v({
  "profile_wrapper": "index-module-scss-module__7xiZnq__profile_wrapper",
});
